import React from 'react';
import ProductOverview from '../../product-overview/ProductOverview';
import product from '../all-gear.json';

const WomensNikePulloverHoodie = () => {
	return (
		<React.Fragment>
			<ProductOverview
				name={product.allGear[16].productName}
				color={product.allGear[16].color}
				size={product.allGear[16].sizes}
				price={product.allGear[16].price}
				img={product.allGear[16].img}
				miniImg1={product.allGear[16].miniImg1}
				miniImg2={product.allGear[16].miniImg2}
				miniImg3={product.allGear[16].miniImg3}
			/>
		</React.Fragment>
	);
};

export default WomensNikePulloverHoodie;
